import { z } from 'zod';
import { errorMessage } from './shared';
import { isProductNameBlackList } from '@modules/MShop/Util/S/Function/util';
import {
  PRODUCT_PRICE__MAX,
  PRODUCT_PRICE__MIN,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import {
  spoIntlSchema,
  spoSchema,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/spo.ts';
import { productStorySchema } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/product_story.ts';
import { storesDeliveryCompanySchema } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/stores_delivery_company.ts';
import { baseProductSchema } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/base_product.ts';
import { Validator } from '@shared/validators';

const productNameSchema = z
  .string({
    required_error: errorMessage.required_product_name,
    invalid_type_error: errorMessage.required_product_name,
  })
  .min(3, { message: errorMessage.min_text })
  .max(100, { message: errorMessage.text_length_100 })
  .refine((name) => !Validator.regex.isNotAllowSpecialCharProductName(name), {
    message: errorMessage.restrict_character2,
  })
  .refine((name) => !isProductNameBlackList(name), {
    message: errorMessage.black_list_name,
  });

const productThumbnailSchema = z.object({
  value: z.array(
    z.object({
      url: z.string(),
      is_pb: z.boolean().optional(),
      width: z.number().optional(),
      height: z.number().optional(),
      is_thumb: z.boolean().optional(),
    }),
  ),
});

const productMembershipSchema = z.object({
  product_id: z.number(),
  membership_id: z.string(),
  created_at: z.date(),
});

const preDiscountProductSchema = z
  .object({
    pre_discount_price: z.number().nullable().default(null),
  })
  .nullable()
  .default(null);

const nessProductMetaSchema = z.object({
  created_at: z.string(),
  end_at: z.string(),
  id: z.number().int(),
  product_id: z.number().int(),
  start_at: z.string(),
  updated_at: z.string(),
});

export const productSchema = z.object({
  name: productNameSchema,
  thumbnails: productThumbnailSchema,
  pre_discount_product: preDiscountProductSchema,
  store_id: z.number().optional(),
  is_public: z.boolean().default(false),
  spo_id: z.number().optional(),
  profit: z
    .number({
      required_error: errorMessage.required,
      invalid_type_error: errorMessage.only_number,
    })
    .int()
    .min(PRODUCT_PRICE__MIN, { message: errorMessage.min_price })
    .max(PRODUCT_PRICE__MAX, { message: errorMessage.max_price }),
  _: z.object({
    products_memberships: z.array(productMembershipSchema).nullable().default(null),
    base_product: baseProductSchema,
    stores_delivery_companies_products: storesDeliveryCompanySchema,
    spo: spoSchema,
    product_story: productStorySchema,
    has_up: z.boolean().optional(),
    ness_product_metas: z.array(nessProductMetaSchema).nullable().default(null),
  }),
});

export const ProductIntlSchema = productSchema.extend({
  name_en: productNameSchema,
  name_jp: productNameSchema,
  _: z.object({
    products_memberships: z.array(productMembershipSchema).nullable().default(null),
    base_product: baseProductSchema,
    stores_delivery_companies_products: storesDeliveryCompanySchema,
    spo: spoIntlSchema,
    product_story: productStorySchema,
    has_up: z.boolean().optional(),
    ness_product_metas: z.array(nessProductMetaSchema).nullable().default(null),
  }),
});
